import React from 'react';
import ReactDOM from 'react-dom';
// import { StoreContext } from 'redux-react-hook';
import { Provider } from 'react-redux';
import { Route } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';

import ReactGA from 'react-ga';
import { trackingId, DEFAULT_CONFIG } from 'config/analytics';

import 'styles/toastr.css';
import 'styles/main.css';
import 'styles/custom.css';

import App from 'components/App';
import ScrollToTop from 'components/ScrollToTop';

import history from './createHistory';
import store from './configureStore';

ReactGA.initialize(trackingId, { ...DEFAULT_CONFIG });

ReactDOM.render(
  <Provider store={store}>
    {/* <StoreContext.Provider value={store}> */}
      <ConnectedRouter history={history}>
        <ScrollToTop>
          <Route path="/" component={App} />
        </ScrollToTop>
      </ConnectedRouter>
    {/* </StoreContext.Provider> */}
  </Provider>,
  document.getElementById('root')
);
